import { uploadedFilesSchema } from '@terra/shared-authorization';
import { z } from 'zod';
import {
  SESSION_ATTACHMENT_ALLOWED_MIME_TYPES,
  SESSION_ATTACHMENT_IMAGE_MIME_TYPES,
  SESSION_ATTACHMENT_MAX_FILES,
  SESSION_ATTACHMENT_MAX_FILE_SIZE_BYTES,
  SESSION_ATTACHMENT_MAX_IMAGE_FILE_SIZE_BYTES,
} from './conversation-attachments.constants';

export const ConversationAttachmentFileTypeSchema = z.enum([
  'PDF',
  'DOCX',
  'XML',
  'CSV',
  'IMAGE',
]);

export const ConversationAttachmentStatusSchema = z.enum([
  'COMPLETED',
  'FAILED',
]);

export const ConversationAttachmentSchema = z.object({
  id: z.string(),
  threadId: z.string(),
  applicationId: z.string().nullable().optional(),
  fileName: z.string(),
  mimeType: z.string(),
  fileType: ConversationAttachmentFileTypeSchema,
  sizeBytes: z.number(),
  extractionStatus: ConversationAttachmentStatusSchema,
  createdAt: z.string(),
});

export const ConversationAttachmentsUploadBodySchema = z
  .object({
    files: uploadedFilesSchema({
      mimeTypes: [...SESSION_ATTACHMENT_ALLOWED_MIME_TYPES],
      maxFiles: SESSION_ATTACHMENT_MAX_FILES,
      maxFileSizeBytes: SESSION_ATTACHMENT_MAX_FILE_SIZE_BYTES,
    }),
    applicationId: z.string().optional(),
  })
  .superRefine((body, context) => {
    body.files.forEach((file, index) => {
      if (
        SESSION_ATTACHMENT_IMAGE_MIME_TYPES.has(file.type) &&
        file.size > SESSION_ATTACHMENT_MAX_IMAGE_FILE_SIZE_BYTES
      ) {
        context.addIssue({
          code: 'custom',
          path: ['files', index],
          message: `Image exceeds the maximum allowed size of ${SESSION_ATTACHMENT_MAX_IMAGE_FILE_SIZE_BYTES} bytes`,
        });
      }
    });
  });

export const ConversationAttachmentsListResponseSchema = z.object({
  attachments: z.array(ConversationAttachmentSchema),
});

export const ConversationAttachmentsUploadResponseSchema = z.object({
  attachments: z.array(ConversationAttachmentSchema),
});

export const ConversationAttachmentDeleteResponseSchema = z.object({
  success: z.boolean(),
});
